




























































import {Component, Prop, Vue, Watch} from "vue-property-decorator";


import Post from "@/components/timeline/_post.vue";
import Feed from "@/components/timeline/_feed.vue";
import {AxiosError, AxiosResponse} from "axios";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import {mapGetters} from "vuex";
import Timeline from "@/components/timeline/_timeline.vue";
import {dateFormat} from "@/script/moment";

import _ from 'lodash';
import MetaSetting from "@/script/metaSetting";

@Component({
    computed: {
        ...mapGetters(["user"]),
        orderedChannelList: function () {
            const channels = this.$store.getters.communityInfo.channels
            return _.orderBy(channels, 'createdAt', 'asc')
        }
    },
    components: {Post, Feed, PulseLoader, Timeline},
})
export default class CommunityTimeline extends Vue {
    metaSetting !: MetaSetting;
    communityId = this.$route.params.community_id;
    community: any = this.$store.getters.communityInfo;
    channelId: any = -1;
    channelList = []

    //parameters
    limit: number = 10;
    offset: number = 0;
    sort: string = '';
    media: string = '';

    //state
    isAddData: boolean = false;
    hasData: boolean = true;

    currPage: string = '';

    user!: any;
    createdDate: string = dateFormat(this.community.createdAt);

    mounted() {

        this.currPage = 'community';

        this.$store.dispatch("loginState")
            .then(() => {
                this.createdDate = dateFormat(this.community.createdAt);
                this.channelList = this.community.channels;
                //@ts-ignore
                if (this.orderedChannelList[0]) {
                    this.$store.commit('currPage', {
                        community: [{
                            id: this.communityId,
                            //@ts-ignore
                            channel_id: this.orderedChannelList[0].id
                        }]
                    })
                }
                // this.createMetaSetting();

            })
    }

    beforeDestroy() {
        this.$store.commit('currPage', null)
    }


    createMetaSetting(){
        console.log(' this.createMetaSetting()');
        this.metaSetting = new MetaSetting({
            title: `${this.community.name} | Zempie.com`,
            meta: [
                {name: 'description', content: this.community.description},
                {property: 'og:url', content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/community/${this.community.id}/timeline`},
                {property: 'og:title', content: `${this.community.name} | Zempie.com`},
                {property: 'og:description', content: this.community.description},
            ]
        });
    }

    reFetch() {
        this.$emit('reFetch')
        // this.communityFetch()
    }

    communityFetch() {
        this.$api.communityInfo(this.communityId)
            .then((res: any) => {
                this.$store.commit('communityInfo', res);
                this.community = res
                this.createdDate = dateFormat(res.createdAt);
            })
            .catch((err: any) => {
                console.log(err)
            })

    }


    allPost() {
        this.channelId = -1;
        this.isActive(-1);
        this.currPage = 'community';
        this.$store.commit('currPage', {
            community: [{
                id: this.communityId,
                //@ts-ignore
                channel_id: this.orderedChannelList[0].id
            }]
        })
    }

    getChannelId(id: string) {
        this.channelId = id;
    }

    initData() {
        this.limit = 10;
        this.offset = 0;
        this.sort = '';
        this.media = '';
        this.isAddData = false;
        this.hasData = false;
    }


    isActive(id?: any) {
        return id === this.channelId;
    }


    openEdit() {
        if (!this.user) {
            this.$store.commit('needLogin', true)
        }
    }


    openChannelTl(channel_id: string) {
        this.channelId = channel_id;
        this.currPage = 'channel'
        this.$store.commit('currPage', {
            community: [{
                id: this.communityId,
                channel_id: channel_id
            }]
        })
    }

    @Watch('$store.getters.currPage')
    generateKey() {
        return Date.now();
    }




}
